import React from 'react'
import { Link } from 'gatsby'

import routes from '../config/routes'
import FlexGrid from '../styled/FlexGrid'
import Tag from '../styled/Tag'

function Tags(props = {}) {
  return (
    <FlexGrid>
      {props.tags.map(tag => (
        <FlexGrid.Item key={tag}>
          <Tag as={Link} to={routes.blog.tag(tag)}>
            {tag}
          </Tag>
        </FlexGrid.Item>
      ))}
    </FlexGrid>
  )
}

export default Tags
